import { Component, HostListener, OnInit, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Entity } from 'src/app/core/models/entity.model';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { User } from 'src/app/core/models/user.model';
import { ConfigService } from 'src/app/core/services/config.service';
import { UserService } from 'src/app/core/services/user.service';
import * as utils from 'src/app/shared/helpers/utils';
import { DdbbUtils } from 'src/app/shared/helpers/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hbo-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  @HostListener('document:shown.bs.collapse', ['$event'])
  onAccordionOpen(event: any) {
    this.openedRow = event.target!.id;
  }

  @HostListener('document:hide.bs.collapse', ['$event'])
  onAccordionClosed(event: Event) {
    this.openedRow = null;
  }

  openedRow!: string | null;

  users$ = new Observable<Pagination<User>>;
  usersCollection$!: User[];
  user: User = utils?.localStorageGetItem('user');
  currentUser: User = utils.localStorageGetItem('user');
  columns!: string[];

  private readonly translate = inject(TranslateService);

  constructor(
    private configSvc: ConfigService,
    private ddbbUtils: DdbbUtils,
    private userService: UserService
  ) { this.user.childEntities = this.configSvc.currentConfigValue.childEntities; }

  get teams() {
    return this.configSvc.currentConfigValue.teams ?? [];
  }

  ngOnInit() {

    switch (this.user.roleId) {
      case 1:
        this.columns = ['id', 'fullname', 'email', 'username', 'entity', 'role', 'profile', 'horizonsTeam', 'team'];
        break;
      default:
        this.columns = ['id', 'fullname', 'email', 'username', 'entity', 'role', 'profile', 'team'];
        break;
    }


    //this.ddbbUtils.getEntityChilds(this.user.entityId).then(result => {
    /*this.user.childEntities = result;
    utils.localStorageSetItem('user', this.user);*/
    const storageUsersFilter = localStorage.getItem('usersListFilter');
    if (storageUsersFilter) {
      this.searchUsers(JSON.parse(storageUsersFilter));
    } else {
      this.searchUsers();
    }
    //});
  }

  searchUsers(pagination?: PaginationRequest) {

    let entities: string | null = null;
    if (this.configSvc.currentConfigValue.usersListSelected?.length) {
      entities = `${this.configSvc.currentConfigValue.usersListSelected?.map((entity: Entity) => entity.id).join(',')}`;
    }
    if (pagination) pagination!.entities = entities;
    this.users$ = this.userService.getUsers(pagination ?? { order: 'desc', entities: entities }).pipe(
      tap(result => {
        // Pre-calculate team names for each user
        this.usersCollection$ = result.data.map(user => ({
          ...user,
          calculatedTeamName: this.calculateTeamName(user)
        }));
      })
    );
  }

  callback = (e: any) => {
    switch (e.action) {
      case 'updated':
        this.usersCollection$.map((u: User) => {
        if (u.id === e.result.id) {
          utils.deepMerge(u, e.result);
          (u as any).calculatedTeamName = this.calculateTeamName(u);
        }
      });
        break;
      default:
        break;
    }
  }

  private calculateTeamName(user: User): string | null {
    // Several memberships do not fit in a cell: name the fact, not the teams.
    if ((user.teams?.length ?? 0) > 1) return this.translate.instant('COMMON.SEVERAL_TEAMS');

    const childs: Entity[] = this.user.childEntities!;
    const childsUserEntity: Entity[] = this.user.childEntities?.concat(this.configSvc.currentConfigValue!.userEntity!)!;
    const entityMatched = this.user?.roleId === 1
      ? childs?.find((child: Entity) => child.id == user.entityId)
      : childsUserEntity?.find((child: Entity) => child.id == user.entityId)!;
    switch (user.roleId) {
      case 2:
        return user?.team?.name!;
      case 3:
      case 4:
        return entityMatched?.team?.name!;
      default:
        return user.team?.name ?? (this.user?.roleId === 1 ? null : '-');
    }
  }
}
